import { render } from "./KOItem.vue?vue&type=template&id=b98e4a18&scoped=true"
import script from "./KOItem.vue?vue&type=script&lang=js"
export * from "./KOItem.vue?vue&type=script&lang=js"

import "./KOItem.vue?vue&type=style&index=0&id=b98e4a18&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b98e4a18"]])

export default __exports__